import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router';
import styled from 'styled-components';
import { useMsal } from '@azure/msal-react';
import { StyledMainGrid } from './styled';
import { Navbar } from './components';
import { userActions } from '../../store';
import { getSystemsError } from '../../shared';
import { handleFetchError, isArrayWithLength, environment, ENVIRONMENTS } from '../../helpers';
import { Routes } from '../../shared/constants';

const StyledEnvironmentWarning = styled.h2`
font-size: 2.325rem;
font-weight: 600;
margin: 0rem;
text-align: center;

@media only screen and (max-width: 550px) {
  font-size: 2.2rem;
  padding-top: 6rem;
}
`;

const BaseLayout = ({ systems, children, systemsRequested, getSystemsForUser }) => {
  const { instance } = useMsal();
  const userToken = instance.getActiveAccount();
  const isAuthenticated = userToken;
  const [ hasSystems, setHasSystems ] = useState(false);

  useEffect(() => {
    if (isAuthenticated && !hasSystems) {
      getSystemsForUser()?.then(setHasSystems(true)).catch((e) => handleFetchError(e, getSystemsError))
    }
  }, [getSystemsForUser, isAuthenticated]);

  const EnvironmentWarning = () => {
    let message = '';
    if (environment === ENVIRONMENTS.DEV) {
      message = 'DEV ENVIRONMENT THIS IS NOT PRODUCTION';
    } else if (environment === ENVIRONMENTS.TEST) {
      message = 'TEST ENVIRONMENT THIS IS NOT PRODUCTION';
    } else if (environment === ENVIRONMENTS.STAGING) {
      message = 'STAGING ENVIRONMENT THIS IS NOT PRODUCTION'
    }
    return (<StyledEnvironmentWarning>{message}</StyledEnvironmentWarning>);
  }

  const logOut = () => {
    instance.logoutRedirect();
  };

  return (
    <Fragment>
      <Navbar 
        systems={systems} 
        isAuthenticated={isAuthenticated} 
        onLogout={logOut} 
      />
      {
        isAuthenticated && (
          <Fragment>
            <Route exact path="/" render={() => isArrayWithLength(systems) ? <Redirect to={Routes[systems[0]]} /> : null} />
            <StyledMainGrid>
              <EnvironmentWarning />
              {children}
            </StyledMainGrid>
          </Fragment>
        )
      }
    </Fragment>
  );
};

const mapState = (state) => ({
  systems: state.user.systems,
  systemsRequested: state.user.systemsRequested,
  unauthorized: state.config.unauthorized
});

const mapDispatch = (dispatch) => ({
  getSystemsForUser: () => dispatch(userActions.getSystemsForUser())
});

export default connect(mapState, mapDispatch)(BaseLayout);
